import posthog from "posthog-js";
import { screenNameFromPath } from "@/lib/observability/screen-name";

if (process.env.NODE_ENV === "production") {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_TOKEN!, {
    api_host: "/ingest",
    ui_host: "https://us.posthog.com",
    defaults: "2026-01-30",
    capture_exceptions: true,
    // Agrega una propiedad `screen` canónica a CADA evento que trae $pathname
    // (rutas `/[agency]/...` → sin el slug de agencia y con los ids colapsados a
    // `:id`). Sin esto, cada agencia/caso es un $pathname distinto y no se puede
    // medir el uso "por pantalla". Ver observability/screen-name.ts.
    before_send: (event) => {
      const path = event?.properties?.$pathname;
      if (event && typeof path === "string") {
        event.properties.screen = screenNameFromPath(path);
      }
      return event;
    },
  });

  // Super properties en CADA evento (incl. pre-login: rageclicks, login fallido,
  // excepciones). Nos deja cortar todo por plataforma y por deploy — clave dado
  // que varios bugs (prompt(), foco de teclado) son solo de la app de escritorio.
  //   · client: "electron" | "web" (detectado por el bridge del preload)
  //   · app_build: SHA del deploy (o "dev") — para atar un error a su release
  const isElectron =
    typeof window !== "undefined" && window.electronAPI?.isElectron === true;
  posthog.register({
    client: isElectron ? "electron" : "web",
    app_build: process.env.NEXT_PUBLIC_BUILD_ID ?? "dev",
  });
}
